module.exports = __webpack_public_path__ + "img/foodie-physician-cookbook_mobile.4c85be3.jpg";